import React, { Fragment } from "react";
import {
  useGetEditFormValues,
  useGetLocationFields,
} from "../../../../profile/form/Validation/UserValues";
import FormTextField from "../../../../../components/form/FormTextField";
import * as mui from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { MobileDatePicker } from "@mui/x-date-pickers";
import CountrySelector from "../../../../../components/form/CountrySelector";
import { useTranslation } from "react-i18next";
import { useGetSingleUserPermissions } from "../../../../../hooks/useGetSingleUserPermissions";
import { useParams } from "react-router-dom";
import Skeletons from "../../../../../components/loader/Skeletons";
import SimpleAlert from "../../../../../components/display/SimpleAlert";
import PopoverInfo from "../../../../../components/display/PopoverInfo";

export default function EmployeeEditForm() {
  const { id } = useParams();
  const { data, loading, error } = useGetSingleUserPermissions(id);
  const { t } = useTranslation();
  const { register, formState, control } = useFormContext();
  const { errors } = formState;
  const profile = data?.user?.userDetails;
  const userValues = useGetEditFormValues(profile);
  const location = useGetLocationFields(profile);
  const [emailSubscription, setEmailSubscription] = React.useState(
    Boolean(profile?.subscribeToEmails)
  );

  function handleSubscription() {
    setEmailSubscription((prev) => !prev);
  }

  if (loading) {
    return <Skeletons numOfSkeletons={10} grid={false} height={50} />;
  } else if (error) {
    return (
      <SimpleAlert severity={"error"} message={"CouldntFetchEmployeeData"} />
    );
  }

  return (
    <Fragment>
      {userValues.map((item, index) => (
        <Fragment>
          <mui.Grid
            container
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <mui.Grid item xs={12} sm={5}>
              <mui.Typography
                sx={{
                  minWidth: 0,
                  whiteSpace: { xs: "normal", sm: "nowrap" },
                  overflowWrap: "anywhere",
                }}
              >
                {t(item.label)}
              </mui.Typography>
            </mui.Grid>
            <mui.Grid item sm={7}>
              <FormTextField
                key={index}
                defaultValue={item.defaultValue}
                label={item.label}
                name={item.name}
                required={item.required}
                errors={errors}
                maxLen={50}
                register={register}
                size="small"
              />
            </mui.Grid>
          </mui.Grid>
          <mui.Divider />
        </Fragment>
      ))}
      <Fragment>
        <mui.Grid
          container
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <mui.Grid item xs={12} sm={5}>
            <mui.Typography>{t("DoB")}</mui.Typography>
          </mui.Grid>
          <mui.Grid item sm={7}>
            <Controller
              name="dob"
              control={control}
              render={({ value, onChange, field }) => (
                <MobileDatePicker
                  format="DD/MM/YYYY"
                  sx={{ width: "100%" }}
                  label={t("DoB")}
                  disableFuture
                  openTo={"year"}
                  value={field.value ?? null}
                  onChange={(newValue) => field.onChange(newValue ?? null)}
                  renderInput={(params) => <mui.TextField {...params} />}
                />
              )}
            />
          </mui.Grid>
        </mui.Grid>
        <mui.Divider />
      </Fragment>
      <Fragment>
        <mui.Grid
          container
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <mui.Grid item xs={12} sm={5}>
            <mui.Typography>{t("SubscribesToEmail")}</mui.Typography>{" "}
          </mui.Grid>
          <mui.Grid item sm={7}>
            <PopoverInfo message={"WhatIsSubscribesToEmail"}>
              <mui.FormControlLabel
                control={
                  <mui.Switch
                    onClick={() => handleSubscription()}
                    checked={emailSubscription}
                    {...register("subscribeToEmails")}
                  />
                }
                label={t("SubscribeToEmails")}
              />
            </PopoverInfo>
          </mui.Grid>
        </mui.Grid>
        <mui.Divider />
      </Fragment>

      <Fragment>
        <mui.Grid
          container
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <mui.Grid item xs={12} sm={5}>
            <mui.Typography>{t("Country")}</mui.Typography>
          </mui.Grid>
          <mui.Grid item xs={7} sm={7}>
            <CountrySelector countryName="country" />
          </mui.Grid>
        </mui.Grid>
        <mui.Divider />
      </Fragment>

      {location.map((item, index) => (
        <Fragment>
          <mui.Grid
            container
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <mui.Grid item xs={12} sm={5}>
              <mui.Typography>{t(item.label)}</mui.Typography>
            </mui.Grid>
            <mui.Grid item sm={7}>
              <FormTextField
                key={index}
                defaultValue={item.defaultValue}
                label={item.label}
                name={item.name}
                required={item.required}
                errors={errors}
                maxLen={item.maxLength ?? null}
                register={register}
                size="small"
              />
            </mui.Grid>
          </mui.Grid>
          <mui.Divider />
        </Fragment>
      ))}
    </Fragment>
  );
}
